import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AsstntsrchServiceService } from 'src/app/services/AsstntsrchService';
import { Router } from '@angular/router';
import { AhctUtils } from 'src/app/core/services/AhctUtils';
import { DropdownModal } from 'src/app/model/ComponentModels/dropdown-modal';
import { AHCTAPIServices } from 'src/app/services/ahCTAPIServices';
import { RfrncDtItemsVO } from 'src/app/model/EligibilityModels/RfrncDtItemsVO';
import * as _ from 'lodash';
import { AssistanceSearchConfirmModel } from 'src/app/model/AssistanceSearchConfirmModel';
import { ReferenceDataVO } from 'src/app/model/EligibilityModels/ReferenceDataVO';
import { ResponseObject } from 'src/app/model/ResponseObject';
import { AppRouteConstants } from 'src/app/core/constants/AppRouteConstants';
import { stringify } from '@angular/core/src/render3/util';
import { ConfirmAssistance } from 'src/app/model/ConfirmAssistance';
import { CustomValidators } from 'src/app/core/validators/custom.validator';
import { SharedService } from 'src/app/services/shared.service';
import { ManageMyAssistanceR2RModel } from 'src/app/model/ManageMyAssistanceR2RModel';
import { ManageMyASTSCService } from 'src/app/services/ManageMyASTSCService';
import { AppModel } from 'src/app/model/AppModel';
import { RemoveAssisterModel } from 'src/app/model/RemoveAssisterModel';
import { ManageAccountModel } from 'src/app/model/ManageAccountModel';
@Component({
  selector: 'app-asstnt-srch-act-home',
  templateUrl: './asstnt-srch-act-home.component.html',
  styleUrls: ['./asstnt-srch-act-home.component.css']
})
export class AsstntSrchActHomeComponent implements OnInit {
  asstntAcctHomeFrm: FormGroup;
 // phoneTypeDd : ReferenceDataVO[];
  // organizationName : string[];
  assisterId: string;
  phoneTypeDd: DropdownModal = new DropdownModal();
  rfrncDt: RfrncDtItemsVO = new RfrncDtItemsVO();
  assistanceSearchConfirmModel: AssistanceSearchConfirmModel = new AssistanceSearchConfirmModel();
  phoneNumberCheck: string= 'N';
  validPhoneCheck: string= 'N';
  /* Start R26 Related Changes */
  confirmAssistance: ConfirmAssistance = new ConfirmAssistance();
  showConfDialog = false;
  /* End R26 Related Changes */
  appModel: AppModel = new AppModel();

  userId:number;


 /* Start R43 PT-17304 Related Changes */
  manageMyAssistanceR2RModel: ManageMyAssistanceR2RModel = new ManageMyAssistanceR2RModel();
  existingAssisterReln: string;
  existingAssisterId: string;
  removeAssisterModel: RemoveAssisterModel = new RemoveAssisterModel();
  mngAccntMdl: ManageAccountModel;
 
   /* End R43 PT-17304 Related Changes */

  constructor(private _apiService: AHCTAPIServices, private _sharedService: SharedService,private formBuilder: FormBuilder, private _asstntSrchService: AsstntsrchServiceService, private _router: Router, private ahctUtils: AhctUtils, private manageMyASTSCService: ManageMyASTSCService) { }

  ngOnInit() {
    this._sharedService.publicBreadCrumbFlagChange(true);
    this._sharedService.publicNonEnrollFlow(false);
    this._sharedService.publicAnonFlowChanges(false);
    this.mngAccntMdl = this._apiService.getManageAccountJsonNAsObj();
    const loginAppId = this.mngAccntMdl.latestApplnId;
    this.createForm();
    if(sessionStorage.getItem('userId') !=null)
    {
     this.userId= Number(sessionStorage.getItem('userId'));
    }
    else{
      this.userId = 73091;
    }
    this._asstntSrchService.getUserAccountInfo(loginAppId).subscribe(
      res => {
        this.assistanceSearchConfirmModel = _.clone(res);
        if(this.assistanceSearchConfirmModel!=null)
        {
          if(this.assistanceSearchConfirmModel.phoneType!=null && this.assistanceSearchConfirmModel.phoneType>0)
          {
            this.asstntAcctHomeFrm.controls.phoneType.patchValue(this.assistanceSearchConfirmModel.phoneType);
            this.asstntAcctHomeFrm.controls.phoneNumber.patchValue(this.assistanceSearchConfirmModel.phoneNumber);
            this.asstntAcctHomeFrm.controls.email.patchValue(this.assistanceSearchConfirmModel.email);
          }

        }
        const arry = ['PhoneType', 'State', 'County', 'PrefLanguage'];
        this._apiService.getRfrncDt(arry).subscribe(
      res => {
        this.rfrncDt = _.clone(res);
        this.phoneTypeDd.options = this.rfrncDt.phoneTypeList;
        
      });
      })
  }

  createForm()
  {
    this.assisterId = localStorage.getItem('assisterId');
    this.asstntAcctHomeFrm = this.formBuilder.group({
      phoneNumber: [(null != this.assistanceSearchConfirmModel.phoneNumber )? this.assistanceSearchConfirmModel.phoneNumber:'',[Validators.required, CustomValidators.isPhoneNumValidValidator()]],
      phoneType: [this.assistanceSearchConfirmModel.phoneType!=null ?this.assistanceSearchConfirmModel.phoneType:'1918'],
      email: [(null != this.assistanceSearchConfirmModel.email)? this.assistanceSearchConfirmModel.email:'', Validators.pattern(this.ahctUtils.emailRegex)],
      });

    if (localStorage.getItem('backFromAstConfirm') == 'YES') {
        localStorage.removeItem('backFromAstConfirm');
        let searchConfirmModel;
        searchConfirmModel = this._asstntSrchService.getASTConfirmJsonNAsObj();
        this.asstntAcctHomeFrm.controls.phoneNumber.patchValue(searchConfirmModel.phoneNumber);
        this.asstntAcctHomeFrm.controls.email.patchValue(searchConfirmModel.email);
        this.asstntAcctHomeFrm.controls.phoneType.patchValue(searchConfirmModel.phoneType);
      }
  }
  numberOnly(event): boolean {
   
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  checkMaxLength(event, maxChar) {
    return this.numberOnly(event) && this.ahctUtils.restrictMaxlength(event, maxChar);
  }

  removePhoneCheckValidation(){
    if(!this.asstntAcctHomeFrm.controls.phoneNumber.value){
      this.validPhoneCheck = 'N';
    }
  }

  validatePhoneNumber() {
    if (
      this.asstntAcctHomeFrm.controls.phoneNumber.value === null ||
      this.asstntAcctHomeFrm.controls.phoneNumber.value === ""
    ) {
      this.phoneNumberCheck = "Y";
    } else if (this.asstntAcctHomeFrm.controls.phoneNumber.value !== null) {
      this.phoneNumberCheck = "N";
    }

    if (
      this.asstntAcctHomeFrm.controls.phoneNumber.value !== null &&
      this.asstntAcctHomeFrm.controls.phoneNumber.value.length === 10
    ) {
      let phone: string;
      phone = this.asstntAcctHomeFrm.controls.phoneNumber.value;
      if (
        phone.startsWith("0") ||
        phone.startsWith("1") ||
        phone.charAt(1) === "9" ||
        phone.charAt(3) === "0" ||
        phone.charAt(3) === "1" ||
        this.asstntAcctHomeFrm.controls.phoneNumber.value.length < 10
      ) {
        this.validPhoneCheck = "Y";
      } else {
        this.validPhoneCheck = "N";
      }
    }
    if (
      this.asstntAcctHomeFrm.controls.phoneNumber.value &&
      this.asstntAcctHomeFrm.controls.phoneNumber.value.length < 10
    ) {
      this.validPhoneCheck = "Y";
    } else if (!this.asstntAcctHomeFrm.controls.phoneNumber.value) {
      this.validPhoneCheck = "N";
    }
  }
  validateData() {
    let checkValue = false;

    if (
      this.asstntAcctHomeFrm.controls.phoneNumber.value !== null &&
      this.asstntAcctHomeFrm.controls.phoneNumber.value.length === 10
    ) {
      let phone: string;
      phone = this.asstntAcctHomeFrm.controls.phoneNumber.value;
      if (
        phone.startsWith("0") ||
        phone.startsWith("1") ||
        phone.charAt(1) === "9" ||
        phone.charAt(3) === "0" ||
        phone.charAt(3) === "1" ||
        this.asstntAcctHomeFrm.controls.phoneNumber.value.length < 10
      ) {
        this.validPhoneCheck = "Y";
        this.phoneNumberCheck = "Y";
        return (checkValue = true);
      }
    }
    if (
      this.asstntAcctHomeFrm.controls.phoneNumber.value === null ||
      this.asstntAcctHomeFrm.controls.phoneNumber.value === "" ||
      this.asstntAcctHomeFrm.controls.phoneNumber.value.length < 10
    ) {
      this.phoneNumberCheck = "Y";
      return (checkValue = true);
    }
    if (this.asstntAcctHomeFrm.valid) {
      return (checkValue = false);
    } else {
      Object.keys(this.asstntAcctHomeFrm.controls).forEach(field => {
        const control = this.asstntAcctHomeFrm.get(field);
        if (control instanceof FormControl) {
          control.markAsDirty({ onlySelf: true });
        }
      });
    }

    return checkValue;
  }


  backButtonAction() {
    this._router.navigateByUrl('/' + AppRouteConstants.AST_SRCH_PRFX_MDUL + '/assistResults');
  }

  /* Start R26 Related Changes */

  /* submitHandler() {
    if (!this.validateData()) {
      const accountHomeInput: AssistanceSearchConfirmModel = Object.assign({}, this.asstntAcctHomeFrm.value);
      // accountHomeInput.userId=36898;
      accountHomeInput.userId = 73091;
      accountHomeInput.assisterId = this.assisterId;
      if (accountHomeInput.phoneType == null || accountHomeInput.phoneType == 0) {
        accountHomeInput.phoneType = 1918;
      }
      this._asstntSrchService.saveAssistAccountInfo(accountHomeInput).subscribe(
        res => {
          const resp: ResponseObject = _.clone(res);
          if (resp.nextPath == 'SUCCESS') {

            this._asstntSrchService.setASTConfirmObjInSession(accountHomeInput);
            this._router.navigateByUrl('/'+ AppRouteConstants.AST_SRCH_PRFX_MDUL + "/assistSearchConfirm");
          }


    });
      this._router.navigateByUrl('/'+ AppRouteConstants.AST_SRCH_PRFX_MDUL +'/assistSearchActConfirm');
    }
    } */
    submitHandler() {
      //alert('1::');
      
      if (!this.validateData()) {
        this.showConfDialog = true;
      }
    }

    closeConfDialog(event) {
      if (event == true) {
        this.showConfDialog = false;
        this.onSubmitNext();
      } else {
        this.showConfDialog = false;
      }
    }

    onSubmitNext() {
       /* Start R43 PT-17304 Related Changes */
      this.existingAssisterId = this._asstntSrchService.getExtAssisterId();
      this.existingAssisterReln = this._asstntSrchService.getExtAsstRelnCd();
      console.log(this.existingAssisterId, this.existingAssisterReln);
        if (this.existingAssisterId!= null && this.assisterId != this.existingAssisterId ){
          if(this.existingAssisterReln == '412'){
            console.log('Removing assister');
            this.removeAssisterModel.assisterId = this.existingAssisterId;
            this.removeAssisterModel.userRoleType="HIX_Individual";
            this.removeAssisterModel.asstReasonCd=1298;
            
           // this.removeAssisterModel.asstCmt=this.removeAssisterFrm.controls.comment.value;
            this.removeAssisterModel.userId=this.userId;
            this.manageMyASTSCService.removeAssister(this.removeAssisterModel).subscribe(
              res => {
                
                this.removeAssisterModel=_.clone(res);
                if(this.removeAssisterModel.nextPath=='SUCCESS')
                {
                  console.log("success");
                  //alert('success');
                }
              }
            );
          }else{
            console.log('Canceling assister');
            this.manageMyASTSCService.cancelAssiterRequest(this.userId).subscribe(
              res => {
                this.appModel = _.clone(res);
                if (this.appModel.nextPath === 'success') {
                  console.log("success");
                }
              }
            );
          }
        }
          
        
        /* End R43 PT-17304 Related Changes */
    
      const accountHomeInput: AssistanceSearchConfirmModel = Object.assign({}, this.asstntAcctHomeFrm.value);
      /* if (sessionStorage.getItem('userId') != null) {
          accountHomeInput.userId  = Number(sessionStorage.getItem('userId'));
      } */
      accountHomeInput.assisterId = this.assisterId;
      if ( accountHomeInput.phoneType === null || accountHomeInput.phoneType === 0 ) {
        accountHomeInput.phoneType = 1918;
      }
      this._asstntSrchService
        .saveAssistAccountInfo(accountHomeInput)
        .subscribe(res => {
          const resp: ResponseObject = _.clone(res);
          if (resp.nextPath == 'SUCCESS') {

            this._asstntSrchService.setASTConfirmObjInSession(accountHomeInput);
            this._router.navigateByUrl('/' + AppRouteConstants.AST_SRCH_PRFX_MDUL + '/assistSearchPostConfirm');
          }
        });

      }

 
    
 /* End R26 Related Changes */

 ngOnDestroy() {
  this._sharedService.publicNonEnrollFlow(true);
  this._sharedService.publicBreadCrumbFlagChange(false);
  this._sharedService.publicAnonFlowChanges(true);
}
}

